export const services = [
  { name: "Oil Change", price: 89, time: "30 min", category: "Maintenance" },
  { name: "Full Synthetic Oil Change", price: 119, time: "30 min", category: "Maintenance" },
  { name: "Brake Inspection", price: 45, time: "30 min", category: "Brakes" },
  { name: "Brake Pads Replacement", price: 150, time: "Quote Required", category: "Brakes" },
  { name: "Brake Pads & Rotors", price: 250, time: "Quote Required", category: "Brakes" },
  { name: "Rotor Replacement", price: 180, time: "Quote Required", category: "Brakes" },
  { name: "Check Engine Light Diagnostics", price: 125, time: "60 min", category: "Diagnostics" },
  { name: "General Vehicle Diagnostics", price: 125, time: "60 min", category: "Diagnostics" },
  { name: "Battery Test", price: 25, time: "20 min", category: "Electrical" },
  { name: "Battery Charging", price: 40, time: "30 min", category: "Electrical" },
  { name: "Battery Replacement", price: 60, time: "30 min", category: "Electrical" },
  { name: "Alternator Testing", price: 65, time: "45 min", category: "Electrical" },
  { name: "Starter Testing", price: 65, time: "45 min", category: "Electrical" },
  { name: "Tire Rotation", price: 35, time: "30 min", category: "Tires" },
  { name: "Tire Balancing", price: 75, time: "45 min", category: "Tires" },
  { name: "Flat Tire Repair", price: 35, time: "30 min", category: "Tires" },
  { name: "Tire Pressure Check", price: 0, time: "15 min", category: "Tires" },
  { name: "Wheel Alignment Check", price: 75, time: "45 min", category: "Steering & Suspension" },
  { name: "Suspension Inspection", price: 75, time: "45 min", category: "Steering & Suspension" },
  { name: "Steering Inspection", price: 75, time: "45 min", category: "Steering & Suspension" },
  { name: "Cooling System Flush", price: 120, time: "60 min", category: "Cooling System" },
  { name: "Radiator Inspection", price: 65, time: "45 min", category: "Cooling System" },
  { name: "Coolant Leak Inspection", price: 85, time: "60 min", category: "Cooling System" },
  { name: "AC Inspection", price: 95, time: "60 min", category: "Heating & AC" },
  { name: "AC Recharge", price: 150, time: "60 min", category: "Heating & AC" },
  { name: "Cabin Air Filter Replacement", price: 45, time: "20 min", category: "Filters" },
  { name: "Engine Air Filter Replacement", price: 35, time: "20 min", category: "Filters" },
  { name: "Headlight Restoration", price: 75, time: "45 min", category: "Detailing" },
  { name: "Pre-Purchase Vehicle Inspection", price: 125, time: "60 min", category: "Inspection" },
  { name: "Fleet Maintenance Consultation", price: 0, time: "30 min", category: "Fleet" },
];

export const dates = ["Today", "Tomorrow", "Friday", "Saturday", "Monday", "Next Tuesday", "Next Wednesday"];
// legacy export retained for compatibility; the live list is built via buildDates() in /data/schedule
export const legacyTimes = ["8:00 AM", "9:00 AM", "10:30 AM", "12:00 PM", "1:30 PM", "3:00 PM", "4:30 PM", "5:30 PM"];

export const categories = [
  "all", "Maintenance", "Brakes", "Diagnostics", "Electrical", "Tires",
  "Steering & Suspension", "Cooling System", "Heating & AC", "Filters",
  "Detailing", "Inspection", "Fleet",
];

export const getDeposit = (service) => {
  if (!service || service.price === 0) return 0;
  return Math.min(50, Math.max(25, Math.round(service.price * 0.5)));
};
